import React, { Suspense } from "react";
import PageSkeleton from "./ui/PageSkeleton";
import { Outlet } from "react-router-dom";

// Was a single black Bootstrap spinner (Loader size="large", colour "dark-text"):
// the only black control in a purple product, saying nothing beyond "wait", and
// occupying one point so the page snapped into existence the instant the chunk
// landed.
//
// The PLAIN variant, deliberately. This boundary wraps the public marketing
// routes ("/", "/platform", "/features", …), whose pages are a hero and prose —
// the dashboard-shaped skeleton (stat tiles, filter bar, table rows) would
// promise a layout that never arrives there, which is worse than a spinner.
//
// Same Suspense boundary, same routes, same timing — only the fallback's
// appearance changed.
const SuspenseWrapper = () => (
  <Suspense fallback={<PageSkeleton variant="plain" />}>
    <Outlet />
  </Suspense>
);

export default SuspenseWrapper;
